import { createSelector } from 'reselect';

const selectVendors = (state: any) => state.vendors;


export const selectVendorsCurrentItem = createSelector([selectVendors], (vendors) => vendors.current);

export const selectVendorsListItems = createSelector([selectVendors], (vendors) => vendors.list);

export const selectVendorsItemById = (itemId: any) =>
    createSelector(selectVendorsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectVendorCreatedItem = createSelector([selectVendors], (vendors) => vendors.create);

export const selectVendorUpdatedItem = createSelector([selectVendors], (vendors) => vendors.update);

export const selectVendorReadItem = createSelector([selectVendors], (vendors) => vendors.read);

export const selectVendorDeletedItem = createSelector([selectVendors], (vendors) => vendors.delete);

export const selectVendorSearchedItems = createSelector([selectVendors], (vendors) => vendors.search);

export const selectVendorItemsCount = createSelector([selectVendors], (vendors) => vendors.count);

export const selectVendorItemsFilter = createSelector([selectVendors], (vendors) => vendors.filter);